import React, { memo } from 'react';
import { NodeBox } from 'js/components/pipelines/cards/components/NodeBox';
import { ResourceName } from 'js/components/pipelines/cards/components/ResourceName';
import { ReactComponent as ResultIcon } from 'new/components/icons/fi-rr-check-circle.svg';
import styles from './Result.module.scss';

interface ResultProps {
  data: any;
}

export const Result = memo((props: ResultProps) => {
  const { data } = props;

  return (
    <NodeBox data={data} className={styles.container} variant="iconOnly" icon={<ResultIcon />}>
      <ResourceName {...props} isCollapsed={true}>
        RESULT
      </ResourceName>
    </NodeBox>
  );
});
